import { Flex } from '@chakra-ui/react';
import { Tag } from '@kula-ai/components';
import type { SuggestedActionChipsProps } from './SuggestedActionChips.types';

// Shared suggested-action chip row (candidate / profile / data-table blocks).
// The primary chip (the backend's "most obvious next click", e.g. the second
// half of a composite ask) always renders first, regardless of payload order.
export const SuggestedActionChips = ({
  actions,
  onSelect,
  disabled = false,
  testIdPrefix,
}: SuggestedActionChipsProps) => (
  <Flex wrap="wrap" gap="8px">
    {[...actions]
      .sort(
        (a, b) => Number(b.kind === 'primary') - Number(a.kind === 'primary')
      )
      .map((a) => (
        <Tag
          key={a.id}
          label={a.label}
          size="md"
          variant={a.kind === 'primary' ? 'primary' : 'outline'}
          disabled={disabled}
          onClick={() => onSelect(a.promptTemplate)}
          className="cursor-pointer"
          data-test-id={`${testIdPrefix}-${a.id}`}
        />
      ))}
  </Flex>
);
